/**
 * URL to download the CSV template used to import multiple passengers.
 */
export const PASSENGERS_CSV_TEMPLATE_URL =
    "https://upcdn.io/FW25b8h/raw/templates/formats/Template-for-Multiple-Passenger.csv?download=true";

/**
 * URL to the guide with the accepted values for each column of the passengers CSV template.
 */
export const PASSENGERS_CSV_GUIDE_URL =
    "/help/reservations/multiple-passenger-csv-upload-guide-step-by-step";
